import Vue from 'vue'
import VueRouter from 'vue-router'
import Layouts from '@/layouts/Header'
import Home from '@/views/home/index'
import Ownervoice from '@/views/home/ownervoice'
import Test from '@/views/home/test'


import Strategic from '@/views/strategic'
import Material from '@/views/strategic/material'
import Soft from '@/views/strategic/soft'
import Designer from '@/views/strategic/designer'


import Join from '@/views/about/join'
import Contact from '@/views/about/contact'
import Introduce from '@/views/about/introduce'
import Founder from '@/views/about/founder'
import Team from '@/views/about/team'


import Consultation from '@/views/consultation'
import Consdetail from '@/views/consultation/consdetail'


import Compety from '@/views/compety'
import Serviceprocess from '@/views/compety/serviceprocess'
import Saleservice from '@/views/compety/saleservice'
import Quality from '@/views/compety/quality'

import Case from '@/views/case'
import Casedetail from '@/views/case/casedetail'



Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Home,
    },
    {
        path: '/test',
        component: Test,
    },
    {
        path: '/strategic',
        component: Strategic,
    },
    {
        path: '/strategic/material',
        component: Material,
    },
    {
        path: '/ownervoice',
        component: Ownervoice,
    },
    {
        path: '/about/join',
        component: Join,
    },
    {
        path: '/about/contact',
        component: Contact,
    },
    {
        path: '/strategic/soft',
        component: Soft,
    },
    {
        path: '/strategic/soft/0',
        component: Soft,
    },
    {
        path: '/strategic/soft/1',
        component: Soft,
    },
    {
        path: '/strategic/soft/2',
        component: Soft,
    },
    {
        path: '/about/introduce',
        component: Introduce,
    },
    {
        path: '/consultation',
        component: Consultation,
    },
    {
        path: '/consultation/0',
        component: Consultation,
    },
    {
        path: '/consultation/100',
        component: Consultation,
    },
    {
        path: '/consultation/200',
        component: Consultation,
    },
    {
        path: '/consultation/300',
        component: Consultation,
    },
    {
        path: '/consultation/400',
        component: Consultation,
    },
    {
        path: '/consultation/500',
        component: Consultation,
    },
    {
        path: '/consultation/600',
        component: Consultation,
    },
    {
        path: '/compety',
        component: Compety,
    },
    {
        path: '/about/founder',
        component: Founder,
    },
    {
        path: '/compety/serviceprocess',
        component: Serviceprocess,
    },
    {
        path: '/compety/saleservice',
        component: Saleservice,
    },
    {
        path: '/about/team',
        component: Team,
    },
    {
        path: '/strategic/designer',
        component: Designer,
    },
    {
        path: '/compety/quality',
        component: Quality,
    },
    {
        path: '/case',
        component: Case,
    },
    {
        path: '/casedetail',
        component: Casedetail,
    },
    {
        path: '/consultation/consdetail',
        component: Consdetail,
    },
    // test import Compety from '@/views/compety'
    // import Serviceprocess from '@/views/compety/serviceprocess'
    // import Saleservice from '@/views/compety/saleservice'
    // import Quality from '@/views/compety/quality'
    // {
    //     path: '/compety',
    //     component: Compety,
    //     redirect: '/compety/index',
    //     name: 'Compety',
    //     children: [
    //         {
    //             path: 'quality',
    //             component: Quality,
    //             name: 'Quality',
    //         },
    //     ]
    // },


    // {
    //     path: '/',
    //     component: Layouts,
    //     redirect: '/home/index'
    // },
  // {
  //   // 主页
  //   path: '/',
  //   component: Layouts,
  //   // name: '代理事物',
  //   iconCls: 'el-icon-message',
  //     // redirect: '/home',
  //   children: [
  //       {
  //         path: '/home',
  //         component: Home,
  //       },
  //       {
  //         path: '/test',
  //         component: Test,
  //       }
  //     ]
  // },
  // {
  //   path: '/',
  //   component: Layouts,
  //   redirect: '/home/index'
  // },
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
